/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export enum ReportType {
  HEIGHT_FOR_AGE = 'Height For Age',

  WEIGHT_FOR_AGE = 'Weight For Age',

  WEIGHT_FOR_LENGTH = 'Weight For Length',

  BMI_FOR_AGE = 'BMI For Age',

  HEAD_CIRCUMFERENCE_FOR_AGE = 'Head Circumference For Age',

  ARM_CIRCUMFERENCE_FOR_AGE = 'Arm Circumference For Age',

  SUBSCAPULAR_SKINFOLD_FOR_AGE = 'Subscapular Skinfold For Age',

  TRICEPS_SKINFOLD_FOR_AGE = 'Triceps Skinfold For Age',

  MOTOR_DEVELOPMENT_MILESTONES = 'Motor Development Milestones',

  WEIGHT_VELOCITY = 'Weight Velocity',

  LENGTH_VELOCITY = 'Length Velocity',

  HEAD_CIRCUMFERENCE_VELOCITY = 'Head Circumference Velocity',
}
